// UserContext.jsx
import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

// 1) Create context
export const UserContext = createContext();


// 2) Create provider
export const UserProvider = ({ children, value }) => {
  // You could store the user in state, so you can update it if needed
  const [user, setUser] = useState(value || null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// 3) Export the context as default or named
export default UserContext;

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object.isRequired,
};
